import { z } from 'zod';
import {
    ComplectationOptionItemList,
    ComplectationOptionSchema,
} from '@/types/complectation/complectation-option.type.ts';

export type ComplectationOptionsList = Record<string, ComplectationOptionItemList>;

export const ComplectationOptionsSchema = z.array(ComplectationOptionSchema);
